webpackJsonp([212094370011963],{

/***/ 1318:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Java: Time Tested, Scalable, and Essential for the Novice and Expert Alike","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike","createdAt":"2017-05-17T20:05:19.121Z","blogAuthor":{"fields":{"name":"Brad Farr","slug":"blog/author/brad-farr"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2V2dAmbHgc6YGe6IGyySuG/652d56d2883070c7607fc1d192dd3e4c/blog-post-blog-java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike.jpg"}}}}}]},"authorJson":{"name":"Brad Farr","slug":"blog/author/brad-farr","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/brad-farr"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-brad-farr-350768c529158dd659a3.js